import { render, staticRenderFns } from "./checkQuestion.vue?vue&type=template&id=6a8b11f8&scoped=true"
import script from "./checkQuestion.vue?vue&type=script&lang=js"
export * from "./checkQuestion.vue?vue&type=script&lang=js"
import style0 from "./checkQuestion.vue?vue&type=style&index=0&id=6a8b11f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b11f8",
  null
  
)

export default component.exports